var {AmpersandApp: productCatalogApp} = require('catalog/libs');

var Cookies = require('js-cookie');
var HPESpinner = require('styleguide/spinner').default;

var HPEServices = require('../../../base/hpe.services');
var HPEConstants = require('../../../base/hpe.constants');
var Router = require('./hpe.productlist.router');

//Require Models
var ProductListAppModel = require('../models/hpe.productlist.app.model');
var PaginationModel = require('../models/hpe.productlist.pagination.model');
var UtilitybarModel = require('../models/hpe.productlist.utilitybar.model');
var ProductCardModel = require('../models/hpe.productlist.productcard.model');
var FiltersModel = require('../models/hpe.productlist.filterlist.model');
var FiltersExpandedModel = require('../models/hpe.productlist.filtergroup.expansion.model');
var BreadcrumbModel = require('../models/hpe.productlist.breadcrumb.model');

//Require Marquee Controller for PLP Page
var MarqueeController = require('../../marquee/hpe.catalog.marquee.controller');

//Require Main Catalog View
var MainView = require('../views/hpe.productlist.app.view');

module.exports = (function() {

    function initialize() {
        var marqueeController; //eslint-disable-line no-unused-vars
        // Validate if is the Product Detail Page Template
        if (document.querySelector('.hpe-product-listing-page')) {
            productCatalog.rootElement = document.querySelector('.hpe-product-listing-page .full-body-content');
            productCatalog.init();
            marqueeController = new MarqueeController.CatalogListingMarqueeController();
        //Validate if it is the Product Detail Page. Perform same init cycle as hpe.product.list.tab.view
        } else if (document.querySelector('.product-listing-tab')) {
            HPEServices.subscribe(HPEConstants.dynamictabcontainer.TAB_CONTAINER_INIT, this, productCatalog.tabInitalize);
        } else {
            return false;
        }
    }

    // Extends our main app singleton
    var productCatalog = productCatalogApp.extend({

        productListLoaderModel: new ProductListAppModel(),
        pagination: new PaginationModel(),
        utilitybar: new UtilitybarModel(),
        productcard: new ProductCardModel(),
        filters: new FiltersModel(),
        filtersExpanded: new FiltersExpandedModel(),
        breadcrumbs: new BreadcrumbModel(),
        isLocalhost: false,
        showSpecs: true,
        isTabInstance: false,
        tabInstanceTitle: '',
        isInitialRender: true,

        //this.rootElement = document.querySelector('.hpe-product-listing-page');
        init: function() {

            if (this.rootElement) {

                //local testing flag
                this.isLocalhost = (window.location.port === '1313');

                //initialize the router
                this.routerInit();

                this.mainView = new MainView({
                    model: this.productListLoaderModel,
                    el: this.rootElement
                });

                //event listeners
                productCatalogApp.on(HPEConstants.catalog.VIEW_UPDATE_REQUEST, this.onViewUpdateRequest);
                productCatalogApp.on(HPEConstants.catalog.VIEW_UPDATE_RENDER, this.onViewUpdateRender);
                productCatalogApp.on(HPEConstants.catalog.VIEW_ERROR, this.onViewError);
                productCatalogApp.on(HPEConstants.catalog.FILTER_COLLAPSE_CHANGE, this.onViewFilterCollapseChange);
                HPEServices.subscribe(HPEConstants.router.BROWSER_URL_CHANGE, this, this.onRouterStateUpdated.bind(this));

                //initial state/setup for either PLP or PDP
                if (!this.isTabInstance) {

                    HPEServices.subscribe(HPEConstants.router.BROWSER_POP_STATE, this, this.onBrowserPopState.bind(this));

                    //PLP: url initial state update triggers bootstrap JSON XHR call to populate children
                    HPEServices.publish(HPEConstants.router.ROUTER_UPDATE_ATTR, this.productListLoaderModel.state);

                } else {

                    //PDP model data from DOM
                    this.productListLoaderModel.pageLabel = document.querySelector('.dynamic-tab-container-nav').getAttribute('data-page-label') || '';
                }
            }
        },

        /**
         * destructor
         */
        destroy: function() {

            //remove event listeners
            productCatalogApp.off(HPEConstants.catalog.VIEW_UPDATE_REQUEST, this.onViewUpdateRequest);
            productCatalogApp.off(HPEConstants.catalog.VIEW_UPDATE_RENDER, this.onViewUpdateRender);
            productCatalogApp.off(HPEConstants.catalog.VIEW_ERROR, this.onViewError);
            productCatalogApp.off(HPEConstants.catalog.FILTER_COLLAPSE_CHANGE, this.onViewFilterCollapseChange);
            HPEServices.unsubscribe(HPEConstants.router.BROWSER_URL_CHANGE, this.onRouterStateUpdated.bind(this));
            // HPEServices.unsubscribe(HPEConstants.dynamictabcontainer.TAB_CONTAINER_INIT, this, this.tabInitalize.bind(this));

            //call destructor in view, ensure child view events removed
            this.mainView.destroy();
            this.mainView.remove();

            //reset values
            productCatalogApp.filtersExpanded.groupsExpanded = {};
            productCatalogApp.utilitybar.hitsSelect.hitCount = '12';
        },

        /**
         * initialize the router with AEM rendered data extracted from DOM
         */
        routerInit: function() {

            var pagePath, pageLabel, stateData;

            if (!this.isTabInstance) {

                //required router initial state data is provided in DOM
                pagePath = this.rootElement.parentNode.getAttribute('data-path');
                pageLabel = this.rootElement.parentNode.getAttribute('data-page-label');
                stateData = this.rootElement.parentNode.getAttribute('data-initial-state');

                if (pagePath && stateData) {

                    //save existing state
                    this.productListLoaderModel.state = this.productListLoaderModel.parseStateString(stateData);
                    this.productListLoaderModel.pageLabel = pageLabel;

                    //look for hits cookie and init router with value or default
                    this.productListLoaderModel.state.hits = this.getHitCountPreference();

                    //format filter state passed from backend to frontend
                    this.productListLoaderModel.state.filters = this.productListLoaderModel.state.filters.map(function(filter) {
                        return {
                            key: filter.key,
                            values: filter.values
                        };
                    });

                    //initialize router
                    this.router = new Router({
                        path: pagePath,
                        currentState: this.productListLoaderModel.state,
                        usePopStateAssign: true
                    });
                }
            }
        },

         /**
         * return value of session cookie to indicate users pagination hit count preference
         * if no user preference specified, should default to 12
         * @return {number}
         */
        getHitCountPreference: function() {
            var url = window.location.href;
            var urlHitParameter = url.substr(url.lastIndexOf('hits-') + 5, 2);

            //If url contains hit count (and it usually does) then use this value
            if (!isNaN(parseFloat(urlHitParameter)) && isFinite(urlHitParameter)) {
                return urlHitParameter;
            }
            var hitCountCookie = Cookies.get(HPEConstants.catalog.HIT_COUNT_COOKIE);
            if (hitCountCookie) {
                return String(hitCountCookie);
            } else {
                return '12';
            }
        },

        /**
         * Update analytics on pagination
        */
        updateAnalytics: function() {
            var pageName = document.querySelector('.hpe-product-listing-page').getAttribute('data-pagename');

            //Push product data to analyics product array.
            var productArray = window.digitalData.product = [];
            this.productcard.models.forEach(function() {
                productArray.push({
                    category: {
                        catalogCategory: pageName
                    }
                });
            });
        },

        /**
         * handle view update request
         * receive view params to update, merge with existing parameters
         * make new JSON request
         * @param {object} params key/value pairs of parameters to use in the update request
         */
        onViewUpdateRequest: function(params) {

            //ensure a list of filters exists
            if (!this.productListLoaderModel.state.filters) {
                this.productListLoaderModel.state.filters = [];
            }

            //ensure hits list exists
            if (!this.productListLoaderModel.state.hits) {
                this.productListLoaderModel.state.hits = this.getHitCountPreference();
            }

            //modify the state by params payload type
            switch (params.type) {
                case 'pagination':
                    this.productListLoaderModel.state.page = params.value;
                    if (!this.isTabInstance) {
                        this.updateAnalytics();
                    }
                    break;
                case 'hitchange': {
                    this.productListLoaderModel.state.page = 1;
                    this.productListLoaderModel.state.hits = params.value;
                    break;
                }
                case 'filteradd':
                    this.productListLoaderModel.filterAdd(params);
                    break;
                case 'filterremove':
                    this.productListLoaderModel.filterRemove(params);
                    break;
                case 'facetremove':
                    this.productListLoaderModel.filterRemoveFacet(params);
                    break;
                case 'clearall':
                    this.productListLoaderModel.state.page = 1;
                    this.productListLoaderModel.state.filters = [];
                    break;
                default:
            }

            //when PDP tab: issue service fetch with current selector state
            if (this.isTabInstance) {
                this.mainView.model.fetch();

            //when PLP page: make the page update request to the router
            } else {
                HPEServices.publish(HPEConstants.router.ROUTER_UPDATE_ATTR, this.productListLoaderModel.state);
            }
        },

        /**
         * handle catalog view render event
         */
        onViewUpdateRender: function() {

            //update focus state after XHR request
            if (!this.isInitialRender) {
                setTimeout(function() {
                    document.querySelector('.product-list-utility-bar-header').focus();
                }, 100);
            }

            //load utag script on first render
            if (this.isInitialRender && !this.isTabInstance) {
                this.updateAnalytics();
            }

            //hide the loader
            this.productListLoaderModel.isLoading = false;
            this.productListLoaderModel.isErrorMode = false;
            HPESpinner.hide();

            //broadcast to components outside of productlist
            HPEServices.publish(HPEConstants.catalog.CATALOG_RESULTS_UPDATED);

            //maintain flag for first app render
            this.isInitialRender = false;
        },

        /**
        * handle filter collapse change event
        * store filtergroup expansion states outside of filter model hierarchy so as to
        * keep values independent of XHR supplied data (which does not contain expansion state)
        * @param {object} filtergroup pay loade representing a "filtergroup" with id and expanded state
        */
        onViewFilterCollapseChange: function(filtergroup) {

            var groupExpandedObj = {};

            //if filter group expansion data exists, update filter expansion state
            //otherwise create new entry
            if (filtergroup && filtergroup.id) {

                if (this.filtersExpanded.groupsExpanded !== undefined) {
                    this.filtersExpanded.groupsExpanded[filtergroup.id] = filtergroup.expanded;
                } else {
                    groupExpandedObj[filtergroup.id] = filtergroup.expanded;
                    this.filtersExpanded.groupsExpanded = groupExpandedObj;
                }
            }
        },

        /**
         * handle view error event
         */
        onViewError: function() {
            this.productListLoaderModel.isLoading = false;
            this.productListLoaderModel.isErrorMode = true;
            HPESpinner.hide();
        },

        /**
         * handle router state update event
         * @param {string} serviceURL is router-generated path to service that matches parameterized request
         */
        onRouterStateUpdated: function(serviceURL) {

            //configure model fetch
            var config = {};

            //use passed service URL for fetch, but use default service url for localhost testing
            if (!this.isLocalhost) {
                config.url = serviceURL;
            }

            //request JSON from server
            this.mainView.model.fetch(config);
        },

        /**
         * handle router popstate event
         * @param {object} e object containing router state from popstate event
         */
        onBrowserPopState: function(e) {

            //re-sync page
            this.productListLoaderModel.state.page = (e.page) ? e.page : '1';

            //re-sync filters
            this.productListLoaderModel.state.filters = e.filters.map(function(catfilter) {
                if (catfilter) {
                    return {
                        key: catfilter.key,
                        values: catfilter.values.slice(0)
                    };
                }
            });
        },

        /**
         * handle compare list change event
         * @param {object} compareData values from compare list manager
         */
        onCompareListChange: function(compareData) {
            this.productListLoaderModel.productCardCompareStateUpdate(compareData.oidList);
        },

        /**
        * handle TAB_CONTAINER_INIT event from hpe.dynamic.tab.container.controller
        * publish router state event to initialize current tab view if initial page load
        */
        tabInitalize: function() {
            var tab = document.querySelector('.dynamic-tab-container-tab.active');
            if (!tab) {
              return;
            }

            var id = tab.getAttribute('data-instance-class');
            var page = tab.getAttribute('data-page');

            //push router change event to trigger view/tab change
            HPEServices.publish(HPEConstants.router.ROUTER_UPDATE_PAGE, {
                page: page,
                state: {
                    id: id
                }
            });
        }
    });

    //initialize compare event outside of app singleton once with app context
    HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_CHANGE, productCatalog, productCatalog.onCompareListChange);

    //proxy productlist events to external components
    productCatalogApp.on(HPEConstants.catalog.CATALOG_SCROLL_TOP_CHANGE, function(status) {
        if (status && status.busy === false) {
            HPEServices.publish(HPEConstants.catalog.SCROLLING_RENDER_UPDATE);
        }
    });

    // Public methods
    return {
        initialize: initialize,
        tabInitialize: productCatalog
    };
})();
